import React, {useEffect, useState} from 'react'
import {Button, Form, Modal, Select, Input, DatePicker, AutoComplete} from "antd";
import {createShippingOrder} from "../../services/serviceShippingOrder";
import {getAllCustomer, getCustomerById} from "../../services/serviceCustomer";
import {getAllOffer, getDetailById, getAllOfferAsSelect} from "../../services/serviceOffer";
import {getAddressByCustomerId} from "../../services/serviceAddress";
import ShippingOrderStockWarehouse from "./ShippingOrderStockWarehouse";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}
const {Option} = Select
const {TextArea} = Input
const dateFormat = 'DD/MM/YYYY'

const shipmentTypes = {
    "VEHICLE": "ARAÇ",
    "CARGO": "KARGO",
    "MANUEL": "ELDEN"
}

const ShippingOrderCreate = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm()
    const [allStock, setAllStock] = useState([])
    const [allCustomer, setAllCustomer] = useState([])
    const [selectedCustomer, setSelectedCustomer] = useState()
    const [customerAddress, setCustomerAddress] = useState([])
    const [customer, setCurrentCustomer] = useState([])
    const [showCargo, setShowCargo] = useState(false)
    const [shipmentChange, setShipmentChange] = useState(false)
    const [selectedOffer, setSelectedOffer] = useState()
    const [bulkList, setBulkList] = useState([])
    const [loadings, setLoadings] = useState([])


    useEffect(() => {
        getAllOfferAsSelect()
            .then(({data}) => {
                setAllStock(data)
            })

    }, [])

    useEffect(() => {
        getAllCustomer()
            .then(({data}) => {
                const customerData = data.map(item => {
                    return {
                        text: item.name,
                        value: item.id
                    }
                })
                setAllCustomer(customerData)
            })
    }, [])

    useEffect(() => {
        const {
            shipmentType
        } = form.getFieldsValue()

        if (shipmentType === 'CARGO') {
            setShowCargo(!showCargo)
        }
    }, [shipmentChange])

    const handleSubmit = () => {
        enterLoadingState(setLoadings)

        const {
            shippingStock,
            customerAddress,
            orderNo,
            note,
            shippingDate,
            shipmentType
        } = form.getFieldsValue()

        let shippingOrderContentList = []
        selectedOffer.bid.contentOfBidList.forEach(item => {
            const matchedStock = bulkList.find(bulkItem => bulkItem.contentId === item.id)
            if (matchedStock && Object.values(matchedStock).length >= 2) {
                const contentItem = {
                    customerStockCode: item.stock.firmStockCode,
                    price: item.linePrice ? item.linePrice : item.stock.price,
                    quantity: matchedStock.quantity || item.amount,
                    stock: {
                        id: item.stock.id
                    },
                    unitPrice: 0,
                    warehouse: {
                        id: matchedStock.warehouse.id
                    }
                }
                shippingOrderContentList.push(contentItem)
            }
        })

        let requestObj = {
            bid: {
                id: shippingStock
            },
            customer: {
                id: selectedCustomer
            },
            customerAddress: {
                id: customerAddress
            },
            customerOrderNo: orderNo,
            dispatchType: 'SHIPMENT',
            dispatchNo: '',
            note: note,
            shipmentDate: shippingDate._d,
            shipmentStatus: 'WAITING',
            shippingOrderContentList: shippingOrderContentList,
            shippingType: shipmentType

        }

        createShippingOrder(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                modalCloser()
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }
    const handleCustomerChange = (v, {key}) => {
        getAddressByCustomerId(key)
            .then(({data}) => setCustomerAddress(data))

        getCustomerById(key)
            .then(({data}) => setCurrentCustomer(data))

        setSelectedCustomer(key)
    }
    const handleShipmentChange = () => {
        setShipmentChange(!shipmentChange)
    }
    const handleOfferChange = (v) => {
        getDetailById(v)
            .then(({data}) => {
                setSelectedOffer(data)
            })
    }
    const handleBulkList = (stockId, key, value, index, contentId) => {
        const mockList = bulkList
        const matchedItem = mockList.find(item => item.contentId === contentId)

        if (matchedItem && key === 'warehouse' && value.id) {
            matchedItem.warehouse = value
            setBulkList([...mockList])
            return
        }

        if (matchedItem && key === 'quantity' && Number(value)) {
            matchedItem.quantity = value
            setBulkList([...mockList])
            return
        }

        if (matchedItem && (!Number(value) || !value)) {
            mockList.splice(mockList.indexOf(matchedItem), 1)
            form.setFieldsValue({
                [`warehouse-${stockId}-${index}`]: '',
                [`quantity-${stockId}-${index}`]: ''
            })
            setBulkList([...mockList])
            return
        }

        const relatedItemAmount = form.getFieldValue(`quantity-${stockId}-${index}`)
        let bulkItem = {
            stock: {
                id: stockId
            },
            [key]: value,
            contentId: contentId
        }

        if (key !== 'quantity' && relatedItemAmount) {
            bulkItem.quantity = relatedItemAmount
        }

        mockList.push(bulkItem)
        setBulkList([...mockList])
    };

    const selectSearch = (input, option) => {
        return (option?.label ?? '').toLocaleLowerCase('tr').includes(input.toLocaleLowerCase('tr'));
    };

    return (
        <React.Fragment>
            <Modal
                open={show}
                closable={false}
                style={{minWidth: '75%'}}
                title={'Yeni Sevk Ekle'}
                footer={[
                    <Button type={'primary'}
                            key={'SubmitButton'}
                            loading={loadings[0]}
                            onClick={() => form.submit()}
                    >Kaydet</Button>,
                    <Button key={'CancelButton'} onClick={() => modalCloser()}>Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    labelAlign={"left"}
                    {...formLayout}
                    onFinish={handleSubmit}
                >
                    <Form.Item
                        label={'Teklif'}
                        name={'shippingStock'}
                        rules={[
                            {required: true, message: 'Bu Alan Zorunludur'}
                        ]}
                    >
                        <Select onChange={handleOfferChange} options={allStock} showSearch allowClear filterOption={selectSearch}/>
                    </Form.Item>
                    {
                        selectedOffer ?
                            <React.Fragment>
                                {
                                    selectedOffer.bid.contentOfBidList.map((item, index) => {
                                        return <ShippingOrderStockWarehouse
                                            key={index}
                                            index={index}
                                            contentId={item.id}
                                            handler={handleBulkList}
                                            formInstance={form}
                                            itemInfo={item}
                                            stockId={item.stock.id}
                                            stockLabel={`${item.stock.code} - ${item.stock.name}`}
                                        />
                                    })
                                }
                            </React.Fragment>
                            : null
                    }
                    <Form.Item
                        label={'Müşteri'}
                        name={'shippingCustomer'}
                        rules={[
                            () => ({
                                validator(rule, value) {
                                    let hasValue = allCustomer.filter(customer => customer.text.toLocaleLowerCase() === value.toLocaleLowerCase())
                                    if (value && hasValue.length > 0) {
                                        handleCustomerChange(true, {key: hasValue[0].value})
                                        return Promise.resolve();
                                    }

                                    return Promise.reject('Lütfen Geçerli Bir Değer Giriniz');
                                },
                            }),
                        ]}
                    >
                        <AutoComplete
                            filterOption={(inputValue, option) =>
                                option.value.toLocaleLowerCase().indexOf(inputValue.toLocaleLowerCase()) !== -1
                            }
                        >
                            {allCustomer.map(item => {
                                return <Option key={item.value} value={item.text}>{item.text}</Option>
                            })}
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Adres'}
                        name={'customerAddress'}
                        rules={[
                            {required: true, message: 'Bu alan boş bırakılamaz'}
                        ]}
                    >
                        <Select>
                            {
                                customerAddress.map(item => {
                                    return <Option key={item.id} value={item.id}>{item.title}</Option>
                                })
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label={'Gönderim Şekli'}
                        name={'shipmentType'}
                        rules={[
                            {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                        ]}
                    >
                        <Select onChange={handleShipmentChange}>
                            {
                                Object.keys(shipmentTypes).map(key => {
                                    return <Option key={key} value={key}>{shipmentTypes[key]}</Option>
                                })
                            }
                        </Select>
                    </Form.Item>
                    {
                        showCargo && customer.cargoCompany ?
                            <Form.Item
                                label={'Kargo Şirketi'}
                                name={'cargoCompany'}
                            >
                                <span>{customer.cargoCompany}</span>
                            </Form.Item> : null
                    }
                    <Form.Item
                        name={'orderNo'}
                        label={'Sipariş Numarası'}
                        rules={[
                            {required: true, message: 'Bu Alan boş bırakılamaz'}
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'Sevkiyat Tarihi'}
                        name={'shippingDate'}
                    >
                        <DatePicker format={dateFormat} placeholder={'Tarih seçiniz'}/>
                    </Form.Item>
                    <Form.Item
                        name={'note'}
                        label={'Not'}
                    >
                        <TextArea/>
                    </Form.Item>


                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default ShippingOrderCreate